<ui-add-to-cart-small-element
  [amount]="productInCartCount()"
  (amountChange)="onProductQuantityChange($event)"
  (remove)="onProductRemoveFromCart()"
  [loading]="isAddToCartLoading()"
  [disabled]="isAddToCartLoading() || !product().prices"
  [isInCart]="productInCartCount() > 0"
  (add)="onAddToCart()"
>
</ui-add-to-cart-small-element>
